module.exports = __webpack_public_path__ + "static/anana-vestige-background-raindrops-4e81d263d3f108899684e76ab18f8d3f.png";